import { isValidUrl } from "@qoohoo/common/utils/string";

export function validateUserSocialLink(formData) {
  const { user_social_link } = formData;
  if (!user_social_link) {
    return { user_social_link: "Please enter a link" };
  }
  if (!isValidUrl(user_social_link)) {
    return { user_social_link: "Please enter a valid link" };
  }
  return null;
}

export function validateUserCommunity(formData) {
  const { user_community_size } = formData;
  // if (!user_community_size) {
  //   return { user_community_size: "Please select a community size" };
  // }
  return null;
}

export function validateUserCategory(formData) {
  const { user_category } = formData;
  if (!user_category) {
    return { user_category: "Please select a category" };
  }
  return null;
}
